// react
import { createContext } from 'react';

// types
import { sseConnectionStatuses, sseNotificationTypes } from '../../@types/unions';

export type SSEConnectionStatus = (typeof sseConnectionStatuses)[number];

export type SSENotificationType = (typeof sseNotificationTypes)[number] | string;

export interface SSENotificationPayload {
	message?: string;
	[key: string]: unknown;
}

export interface SSENotification {
	id?: string;
	origination?: string;
	payload?: SSENotificationPayload;
	receivedAt?: string;
	status?: string;
	timestamp?: string;
	transactionId?: string;
	type: SSENotificationType;
	userId?: string;
	version?: string;
}

export interface ContextSSEProps {
	clearNotifications: () => void;
	connect: () => void;
	connectionId: string | null;
	disconnect: () => void;
	isConnected: boolean;
	messageCount: number;
	notifications: SSENotification[];
	sendTestNotification: (message?: string) => Promise<boolean>;
	status: SSEConnectionStatus;
	uptime: number;
}

// noop functions for default context
const noop = () => {
	// default no-op
};

export const defaultSSEContext: ContextSSEProps = {
	clearNotifications: noop,
	connect: noop,
	connectionId: null,
	disconnect: noop,
	isConnected: false,
	messageCount: 0,
	notifications: [],
	sendTestNotification: async () => false,
	status: 'disconnected',
	uptime: 0,
};

export const ContextSSE = createContext<ContextSSEProps>(defaultSSEContext);
